var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokerChannelConnecting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 249,
    viewBox: "0 0 163 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0336 146.118H34.4256V208.889H37.0336V146.118Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2976 152.63H22.6896V215.401H25.2976V152.63Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2912 157.058H46.6832V219.829H49.2912V157.058Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6816 197.299H12.9096C14.7352 200.554 17.2128 203.289 20.3424 205.373V248.479H45.2488V205.373C48.3784 203.289 50.856 200.424 52.6816 197.299Z",
    fill: "#0FA398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.548 205.373H16.3V205.894H64.548V205.373Z",
    fill: "#0FA398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.09 219.959L153.481 163.569C153.481 163.569 143.701 169.56 145.526 177.634C146.439 181.541 147.874 184.145 145.135 187.401C142.397 190.657 141.223 192.741 141.484 196.517C141.745 200.294 146.048 201.596 145.526 205.894C145.005 210.191 142.266 213.447 142.658 216.052C143.831 222.042 148.917 224.387 148.917 224.387L153.09 219.959Z",
    fill: "#16B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 175.42H149.569V175.941H163V175.42Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.914 194.434H147.482V194.955H160.914V194.434Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.696 215.14H148.265V215.661H161.696V215.14Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.248 122.937C43.684 113.17 29.34 111.868 22.9504 123.979C17.604 134.398 4.69442 130.751 1.17362 140.388C-5.34638 157.839 17.604 164.611 27.384 155.495C34.0344 149.244 42.6408 153.02 50.0736 159.011C62.2008 168.778 80.9784 147.941 69.112 138.304C59.7232 130.751 53.8552 134.918 48.248 122.937Z",
    fill: "#16B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.056 219.438L116.447 157.709C116.447 157.709 105.624 164.22 107.71 173.206C108.623 177.504 110.188 180.369 107.319 183.885C104.32 187.401 103.016 189.745 103.277 193.913C103.538 198.08 108.362 199.382 107.71 204.201C107.058 208.889 104.059 212.405 104.581 215.27C105.754 221.782 111.362 224.387 111.362 224.387L116.056 219.438Z",
    fill: "#16B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.01 170.732H112.274V171.253H127.01V170.732Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.575 214.229H110.84V214.749H125.575V214.229Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.79 221V147.16C136.79 147.16 124.271 154.713 126.618 165.132C127.792 170.08 129.618 173.336 126.097 177.504C122.706 181.671 121.011 184.275 121.402 189.094C121.794 193.913 127.27 195.475 126.618 200.945C125.966 206.415 120.62 211.494 123.098 213.838C125.445 216.182 131.052 224.517 131.052 224.517L136.79 221Z",
    fill: "#16B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.879 219.307H153.742L148.526 248.609H131.965L126.879 219.307Z",
    fill: "#0FA398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0632 169.429C89.0632 157.057 117.36 161.876 126.097 126.844C133.138 98.4539 125.184 95.5889 125.184 95.5889H91.8016H74.8496H41.4672C41.4672 95.5889 32.8608 98.7144 40.5544 126.844C50.0736 161.876 77.588 157.188 77.588 169.429C77.588 185.578 50.9864 176.983 40.5544 212.015C32.2088 240.014 41.4672 243.27 41.4672 243.27H74.8496H91.6712H125.184C125.184 243.27 133.269 240.275 126.097 212.015C118.273 180.759 89.0632 185.578 89.0632 169.429Z",
    fill: "#A6E8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.053 111.477H37.9464C32.9912 111.477 29.0792 108.091 29.0792 103.924V97.6725C29.0792 93.5051 33.1216 90.1191 37.9464 90.1191H128.053C133.008 90.1191 136.92 93.5051 136.92 97.6725V103.924C137.05 108.091 133.008 111.477 128.053 111.477Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.189 75.0125H71.3288V83.6076C71.3288 88.2959 74.1976 90.3796 78.892 90.3796H106.276C110.97 90.3796 115.534 88.2959 115.534 83.6076V83.4774C115.665 78.7891 111.883 75.0125 107.189 75.0125Z",
    fill: "#16B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.274 82.3054L119.577 130.751H113.057C113.057 130.751 103.929 101.71 102.886 91.2913C101.842 80.8729 108.102 79.8311 108.102 79.8311L115.274 82.3054Z",
    fill: "#16B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.54 81.6543L98.9736 130.751H92.4536C92.4536 130.751 82.9344 99.2353 81.8912 88.8169C80.848 78.3985 87.4984 79.831 87.4984 79.831L94.54 81.6543Z",
    fill: "#16B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.446 130.751H113.057V135.569H125.966C126.879 135.569 127.14 133.616 126.358 133.225L119.446 130.751Z",
    fill: "#FE958E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9736 130.751H92.584V135.569H105.624C106.537 135.569 106.798 133.616 106.015 133.225L98.9736 130.751Z",
    fill: "#FE958E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3288 75.4031H98.0608L101.451 35.8131C101.712 32.2969 98.9736 29.1714 95.3224 29.1714H74.0672C70.5464 29.1714 67.6776 32.1667 67.9384 35.8131L71.3288 75.4031Z",
    fill: "#0FA398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0648 31.6458H87.2376C88.5416 31.6458 89.5848 30.4738 89.5848 29.0412V23.9623C89.5848 22.5297 88.5416 21.3577 87.2376 21.3577H83.0648C81.7608 21.3577 80.7176 22.5297 80.7176 23.9623V29.0412C80.7176 30.4738 81.7608 31.6458 83.0648 31.6458Z",
    fill: "#E98896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0616 21.2275C93.3664 26.8274 88.672 26.046 83.0648 24.353C77.4576 22.66 74.1976 16.7997 75.8928 11.0695C77.4576 5.46965 83.456 2.2139 89.0632 3.90689C94.8008 5.59988 96.7568 15.6276 95.0616 21.2275Z",
    fill: "#FFB3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.799 32.8179L113.578 54.6965L103.668 58.8639L95.844 45.9711L100.799 32.8179Z",
    fill: "#0FA398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0688 30.2133C55.6808 41.0224 52.812 55.3477 52.812 55.3477C52.0296 57.0407 52.6816 59.6453 54.3768 60.1662L78.6312 72.2776L82.0216 66.5475L65.0696 53.6547L77.588 40.241L76.936 29.1714C76.936 29.1714 70.0248 28.5203 68.0688 30.2133Z",
    fill: "#0FA398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3131 54.599L67.9492 54.9722L82.1488 68.7831L82.5127 68.4099L68.3131 54.599Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8816 64.5472L63.6389 65.0083L79.9127 73.5542L80.1554 73.0931L63.8816 64.5472Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.577 72.1475H77.8488V75.6637H119.577V72.1475Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.24 72.2776H88.9328L89.7152 67.5894H81.6304C80.0656 67.5894 78.892 68.6312 78.6312 70.194L78.24 72.2776Z",
    fill: "#FFB3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.064 72.2776H119.577L124.141 51.571H90.628L86.064 72.2776Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.538 62.5105C103.538 63.6826 104.581 64.7245 105.754 64.7245C106.928 64.7245 107.971 63.6826 107.971 62.5105C107.971 61.3385 106.928 60.2966 105.754 60.2966C104.581 60.2966 103.538 61.2082 103.538 62.5105Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9448 228.945C42.9016 225.949 47.0744 210.582 48.3784 207.717C49.6824 204.852 80.4568 186.229 82.804 186.359C85.1512 186.62 114.491 201.987 118.142 208.498C121.794 215.01 122.576 228.945 122.576 228.945H43.9448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.053 249H37.9464C32.9912 249 29.0792 245.614 29.0792 241.447V235.196C29.0792 231.028 33.1216 227.642 37.9464 227.642H128.053C133.008 227.642 136.92 231.028 136.92 235.196V241.447C137.05 245.614 133.008 249 128.053 249Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3256 160.704C81.8912 160.704 70.6768 154.583 64.4176 150.025C58.1584 145.467 59.5928 143.514 61.94 142.732C64.2872 141.951 107.45 142.211 109.275 144.035C111.101 145.858 101.06 151.848 96.6264 154.844C93.4968 157.058 86.064 160.704 83.3256 160.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6312 22.0089C79.2832 22.5298 81.6304 21.7484 80.196 20.0554C78.3704 17.9717 76.8056 14.3253 79.6744 13.6741C82.5432 13.023 81.7608 16.5392 83.0648 16.5392C84.3688 16.5392 83.1952 11.9811 83.7168 9.37654C84.2384 6.77193 90.8888 7.16262 94.1488 6.6417C97.4088 6.12078 97.8 -0.781413 89.4544 0.130198C83.7168 0.781349 79.6744 2.47434 76.0232 7.81378C73.4152 11.8509 74.7192 18.4926 78.6312 22.0089Z",
    fill: "#03053F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.614 163.96H131.182V164.481H144.614V163.96Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.223 187.01H127.792V187.531H141.223V187.01Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.614 210.322H131.182V210.843H144.614V210.322Z",
    fill: "#8FD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3872 176.071C13.3008 177.894 15.9088 182.583 21.2552 181.541C26.6016 180.629 29.34 178.024 26.3408 175.42C23.3416 172.685 19.2992 172.685 15.3872 176.071Z",
    fill: "#16B5C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5136 166.304C34.1648 159.662 39.6416 165.262 43.1624 166.955C50.0736 170.341 51.2472 165.913 54.8984 167.736C58.5496 169.56 57.1152 174.378 49.1608 175.68C42.38 176.983 26.8624 173.076 30.5136 166.304Z",
    fill: "#16B5C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 249,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokerChannelConnecting);
export default __webpack_public_path__ + "static/media/broker-channel-connecting.cf235b2eefaae5b554e1c3763ede2f3e.svg";
export { ForwardRef as ReactComponent };